import { Injectable } from '@angular/core';
import { Observable, of, from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InternetConnectionService {

  constructor() { }

  /**
   * Verifica se há conexão com a internet.
   * Primeiro verifica navigator.onLine (se false, retorna false imediatamente).
   * Depois tenta acessar um arquivo local (assets/ping.txt),
   * se falhar, tenta acessar o Cloudflare.
   * 
   * @returns Observable<boolean> - true se há conexão, false caso contrário
   */
  checkInternetConnection(): Observable<boolean> {
    // Se navigator.onLine é false, certeza que não tem internet
    if (!navigator.onLine) {
      return of(false);
    }

    // Se navigator.onLine é true, verifica de fato a conectividade
    return from(this.checkConnectivity());
  }

  /**
   * Verifica conectividade real tentando acessar recursos
   */
  private async checkConnectivity(): Promise<boolean> {
    // Primeiro tenta o arquivo local
    try {
      await fetch('assets/ping.txt', { 
        method: 'GET',
        cache: 'no-cache'
      });
      return true;
    } catch (error) {
      // Se falhar, tenta o Cloudflare
      try {
        await fetch('https://www.cloudflare.com/cdn-cgi/trace', {
          method: 'GET',
          cache: 'no-cache'
        });
        return true;
      } catch (cloudflareError) {
        return false;
      }
    }
  }

  /**
   * Verifica se há conexão com a internet de forma síncrona usando navigator.onLine
   * Note: Este método indica apenas se o dispositivo está conectado a uma rede,
   * não garante acesso à internet.
   */
  isOnline(): boolean {
    return navigator.onLine;
  }
}
